module.exports = __webpack_public_path__ + "static/media/top-nerds.8891ff92.svg";